import {ValidationError} from '../../models/validation-error.model';

export namespace PasswordChangeActions {
    export class FormFailure {
        static readonly type = 'PasswordChange.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class Submit {
        static readonly type = 'PasswordChange.Submit';
    }

    export class OpenModal {
        static readonly type = 'PasswordChange.OpenModal';
    }

    export class CloseModal {
        static readonly type = 'PasswordChange.CloseModal';
    }

    export class OldPasswordReset {
        static readonly type = 'PasswordChange.OldPasswordReset';

        constructor(public readonly token: string) {
        }
    }
}
